export default "__VITE_ASSET__Ctt_6KkO__"